import { notifyError, notifySuccess } from "../../../ui/dls/dls-snackbar/dls-snackbar";
import { deleteBroadcastMessage } from "../api/api";
import { BroadcastCriteria, SaveBroadcastMessageRequest } from "../model/broad-cast-api-request";
import { IMessageGeneral, IMessageNav, IMessageUnion } from "../model/broad-cast-message";
import { BROADCASTCONTROLS, CRITERIANAMES } from "../model/enum";

const storefrontCriteria = { criteriaId: 10, criteriaValue: CRITERIANAMES.INDS }
const getBaseObject = (message: IMessageUnion, broadcastCriterias: BroadcastCriteria[]) => {

    return {
        broadcastId: message.id ? Number(message.id + "") : undefined,
        broadcastCriterias: [...broadcastCriterias],
        startDate: getStartDateISO(message.startDate),
        endDate: getEndDateISO(message.endDate),
        icon: {
            iconId: Number(message.iconCategory)
        },
        priority: {
            priorityId: Number(message.priority)
        },
        status: "ACTIVE",
        broadcastControls: [
            { controlId: BROADCASTCONTROLS.Standalone, controlFlag: message.isStandalone ? 'Y' : 'N' },
            { controlId: BROADCASTCONTROLS.PackSlipIncluded, controlFlag: message.isPackSlip ? 'Y' : 'N' },
            { controlId: BROADCASTCONTROLS.Confirmation, controlFlag: message.isConfirmation ? 'Y' : 'N' },
            { controlId: BROADCASTCONTROLS.IDM, controlFlag: message.isIDM ? 'Y' : 'N' },
            { controlId: BROADCASTCONTROLS.IDMios, controlFlag: message.isIDM && message.idmPlatform === 'ios' ? 'Y' : 'N' },
            { controlId: BROADCASTCONTROLS.IDMWindows, controlFlag: message.isIDM && message.idmPlatform === 'windows' ? 'Y' : 'N' },
            { controlId: BROADCASTCONTROLS.Push, controlFlag: message.isEnablePush ? 'Y' : 'N' },
            { controlId: BROADCASTCONTROLS.Acknowledgment, controlFlag: message.isNeedAckWeb ? 'Y' : 'N' },
            { controlId: BROADCASTCONTROLS.Web, controlFlag: message.isWeb ? 'Y' : 'N' },
            { controlId: BROADCASTCONTROLS.IDMBoth, controlFlag: message.isIDM && message.idmPlatform === 'both' ? 'Y' : 'N' }
        ]
    } as SaveBroadcastMessageRequest;
}
 


export const prepareBroadCastMessage = (message: IMessageUnion, broadcastCriterias: BroadcastCriteria[]): SaveBroadcastMessageRequest => {

    const finalObject = getBaseObject(message, broadcastCriterias);
    finalObject.broadcastCriterias.push({ ...storefrontCriteria });
    finalObject.messageDesc = btoa(message.messageText);
    return finalObject;
}



export const deleteMessage = (broadcastId: number | string, onDone: () => void, setLoader: React.Dispatch<React.SetStateAction<boolean>>): void => {
    setLoader(true);
    const finalObject = {
        broadcastIds: [+(broadcastId + "")]
    }

    deleteBroadcastMessage(finalObject).then((data) => {
        notifySuccess(data || "Message deleted successfully");
        onDone();
    }).catch((error) => {
        notifyError(error.message);
    }).finally(() => setLoader(false));
}

const getUTCDateParts = (dateString: string) => {
    try {
        const datePart = dateString.split('T')[0];
        const [year, month, day] = datePart.split('-').map(Number);

        if ([year, month, day].some(Number.isNaN)) {
            return null;
        }

        return { year, month, day };
    } catch {
        return null;
    }
}

const getStartDateISO = (dateString: string): string => {
    try {
        const dateParts = getUTCDateParts(dateString);

        if (!dateParts) {
            return "";
        }

        const selectedDateAtUTC = new Date(Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day, 0, 0, 0));
        const currentUTCDate = new Date();
        const isTodayUTC = selectedDateAtUTC.toISOString().split('T')[0] === currentUTCDate.toISOString().split('T')[0];

        if (isTodayUTC) {
            return currentUTCDate.toISOString();
        }

        return selectedDateAtUTC.toISOString();
    } catch {
        return "";
    }
}

const getEndDateISO = (dateString: string): string => {
    try {
        const dateParts = getUTCDateParts(dateString);

        if (!dateParts) {
            return "";
        }

        return new Date(Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day, 23, 59, 59, 999)).toISOString();
    } catch {
        return "";
    }
}


export const searchCriteriaGeneralMessages = () => {
    return ({ storefront: CRITERIANAMES.INDS, additionalCriterias: { general: CRITERIANAMES.GENERAL } });
}

export const searchCriteriaNavdbMessagesGroup = () => {
    return ({ storefront: CRITERIANAMES.INDS, additionalCriterias: { NAVDB_SPECIFIC: CRITERIANAMES.NAVDBSPECIFICGROUP } });
}

export const searchCriteriaNavdbMessagesIdent = () => {
    return ({ storefront: CRITERIANAMES.INDS, additionalCriterias: { NAVDB_SPECIFIC: CRITERIANAMES.NAVDBSPECIFICIDENT } });
}

export const searchCriteriaACSpecific = () => {
    return ({ storefront: CRITERIANAMES.INDS, additionalCriterias: { AC: CRITERIANAMES.ACSPECIFIC } });
}


export const searchCriteriaEBSpecific = () => {
    return ({ storefront: CRITERIANAMES.INDS, additionalCriterias: { EB_SPECIFIC: CRITERIANAMES.EBSPECIFIC } });
}